angular.module("screensApp")
  .filter("money", function () {
    return function (amount, currency) {
      if (!amount || !currency) return false;
      var currencyFormat;
      switch (currency) {
        case "EUR":
          currencyFormat = amount.toFixed(2) + "€";
          break;
        case "USD":
          currencyFormat = "$" + amount.toFixed(2);
          break;
        case "NGN":
          currencyFormat = "₦" + amount.toFixed(2);
          break;
        case "SBC":
          currencyFormat = amount.toFixed(2) + "SBC";
          break;
      }
      return currencyFormat;
    };
  })
  .filter("customDate", function () {
    return function (dateString) {
      if (dateString) {
        dateString = reformatDate(dateString);

        if (isToday(dateString)) {
          return dateString.split(" ")[1];
        } else {
          return moment(new Date(dateString)).format("DD.MM.");
        }
      }

      return null;
    };
  });

function reformatDate(dateStr) {
  var dateStr = dateStr.split(" "),
    date = dateStr[0],
    time = dateStr[1];

  var tempDate = date.split(".");
  date = [];
  date[0] = tempDate[2];
  date[1] = tempDate[1];
  date[2] = tempDate[0];
  date = date.join(".");

  return date + " " + time;
}

function isToday(dateStr) {
  var actualDay = moment().format("DD"),
    actualMonth = moment().format("MM"),
    winningDay = moment(new Date(dateStr)).format("DD"),
    winningMonth = moment(new Date(dateStr)).format("MM");

  if (actualDay == winningDay && actualMonth == winningMonth) return true;
  else return false;
}
